/*  eslint-disable array-callback-return */

import Dialog from '@material-ui/core/Dialog';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import { connect } from 'react-redux';
import { addAttribute } from '../../../../Actions/Form';
import AccessOverview from './AccessOverview';

const AccessWay = (props) => {
    const saveEwill = (data) => {
        let input = {};
        Object.keys(data).map((item) => {
            input[item] = {
                value: data[item],
            };
        });
        let json = {
            url: input.ID.value ? `important/${input.ID.value}` : 'important',
            method: input.ID.value ? 'PUT' : 'POST',
            system: {
                id: input.ID.value,
            },
            general: {
                importantType: 'accessWay',
                name: input.remark ? input.remark.value : '',
                contactID: input.accessContactID ? input.accessContactID.value + ';' : '',
            },
            accessWay: {
                accessWayType: 'car',
                location: input.location ? input.location.value : '',
            },
            meta: {
                additionalInfo: input.remark ? input.remark.value : '',
                tags: 'tag1;tag2',
            },
        };
        props.handleRequest('update', json);
        setaddNew(false);
    };

    const [addNew, setaddNew] = React.useState(false);
    const [newRecord, setnewRecord] = React.useState({
        accessType: '',
        remark: '',
        location: '',
        accessContactID: '',
        ID: '',
        passwordManager: 'yes',
    });

    React.useEffect(() => {
        if (props.form.accountData && props.form.accountData.importantList) {
            let data = props.form.accountData.importantList.filter((item) => {
                return item.accessWay;
            });
            let accessWay = [];
            data.map((item) => {
                accessWay.push({
                    accessType: item.accessWay.accessWayType,
                    remark: item.general.name,
                    location: item.accessWay.location,
                    accessContactID: item.general.contactID?.replaceAll(";", ""),
                    ID: item.system.id,
                    passwordManager: 'yes',
                });
            });
            setpersonalData(accessWay);
        } else {
            setpersonalData([]);
        }
    }, [props.form.accountData && props.form.accountData.importantList]);

    const changeHandler = (event, personal) => {
        let data = personalData;
        let newData = newRecord;
        newData[event.target.name] = event.target.value;
        setnewRecord(newData);
        setpersonalData(JSON.parse(JSON.stringify(data)));
    };

    const showAddAccess = (finance) => {
        setaddNew(true);
        if (finance) {
            let newData = {};
            Object.keys(finance).map((item) => {
                newData[item] = finance[item];
            });
            setnewRecord(newData);
            props.addAttribute({
                name: 'selectedAccess',
                value: finance,
            });
        } else {
            setnewRecord({
                accessType: '',
                remark: '',
                location: '',
                accessContactID: '',
                ID: '',
                passwordManager: 'yes',
            });
            props.addAttribute({
                name: 'selectedAccess',
                value: {},
            });
        }
    };
    const hideEdit = () => {
        setaddNew(false);
    };
    const [personalData, setpersonalData] = React.useState([]);
    return (
        <React.Fragment key={props.key}>
            {addNew === true && (
                <Dialog
                    open={addNew}
                    fullScreen={props.fullScreen}
                    disableEscapeKeyDown={true}
                    onClose={hideEdit}
                    aria-labelledby='responsive-dialog-title'
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            position: 'relative',
                        }}
                    >
                        <div
                            className='mm-form-container'
                        >
                            <div className='mm-login-container' style={{ boxShadow: 'none' }}>
                                <div className='mm-login-header'>
                                    {props.form.selectedAccess && props.form.selectedAccess.ID
                                        ? props.form.language.ACCESS_EDIT
                                        : props.form.language.ACCESS_ADD}
                                </div>
                                <div>
                                    <div className='login-field-label login-field-label-height'>
                                        {props.form.language.DESCRIPTION_LABEL}
                                    </div>
                                    <div className='login-field-input'>
                                        <input
                                            type='text'
                                            placeholder={props.form.language.DESCRIPTION_LABEL}
                                            name='remark'
                                            value={newRecord.remark}
                                            autoComplete="off"
                                            onChange={(event) => changeHandler(event, newRecord)}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className='login-field-label login-field-label-height'>
                                        {props.form.language.LOCATION_LABEL}
                                    </div>
                                    <div className='login-field-input'>
                                        <input
                                            type='text'
                                            placeholder={props.form.language.LOCATION_LABEL}
                                            name='location'
                                            autoComplete="off"
                                            value={newRecord.location}
                                            onChange={(event) => changeHandler(event, newRecord)}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className='login-field-label login-field-label-height'>
                                        {props.form.language.CONTACT_PERSON_TITLE}
                                    </div>
                                    <div className='login-field-input'>
                                        <select
                                            className='mm-field-input '
                                            name={'accessContactID'}
                                            value={newRecord.accessContactID}
                                            autoComplete="off"
                                            onChange={(event) => changeHandler(event, newRecord)}
                                        >
                                            <option value=''>
                                                {props.form.language.SELECT_OPTION}
                                            </option>
                                            {props.contactList?.map(
                                                    (contact) => {
                                                        if (contact) {
                                                            return (
                                                                <option value={contact.system.id} key={`contact-${contact.system.id}`}>
                                                                    {contact.privateData.firstName +
                                                                        ' ' +
                                                                        contact.privateData
                                                                            .lastName}
                                                                </option>
                                                            );
                                                        }
                                                    }
                                                )}
                                        </select>
                                    </div>
                                </div>
                                <div
                                    className='mm-input-submit'
                                    style={{
                                        display: 'flex',
                                        marginBottom: '15px',
                                        justifyContent: 'center',
                                    }}
                                >
                                    
                                    <button
                                        style={{
                                            textAlign: 'center',
                                            width: '150px',
                                            marginTop: '24px',
                                            marginRight: '20px',
                                        }}
                                        className='primary-button-blue'
                                        onClick={() => {
                                            saveEwill(newRecord);
                                            hideEdit();
                                        }}
                                    >
                                        {props.form.language.SAVE}
                                    </button>
                                    <button
                                        style={{
                                            textAlign: 'center',
                                            marginTop: '24px',
                                            
                                        }}
                                        className='secondary-button'
                                        onClick={hideEdit}
                                    >
                                        {props.form.language.CANCEL}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            )}
            {personalData &&
                personalData.length > 0 &&
                personalData.map((data) => {
                    return (
                        <AccessOverview
                            key={`access${data.ID}`}
                            data={data}
                            showAddAccess={() => showAddAccess(data)}
                            handleRequest={(type, data) => props.handleRequest(type, data)}
                            contactList={props.contactList}
                        />
                    );
                })}
            <span
                id={props.type}
                onClick={(event) => {
                    showAddAccess();
                }}
                style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '8px',
                }}
            >
                <span className=''>
                    <span className='ewill-secondary-alert-sm'>
                        <AddIcon />
                    </span>
                </span>
                <span className='momentio-text-normal' style={{ marginLeft: '15px' }}>
                    {personalData.length > 0
                        ? props.form.language.ACCESS_ADD_MULTIPLE
                        : props.form.language.ACCESS_ADD_SINGLE}
                </span>
            </span>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return { ...state };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addAttribute: (payload) => dispatch(addAttribute(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccessWay);
